import { Icon } from '@mui/material';
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material';

import { SupplierStatusEnum, SupplierStatusFormEnum } from '../../../core/enums/store/supplier';

export const getSupplierStatusIcon = (status) => {
    if (status) {
        return (
            <Icon title={ SupplierStatusEnum.ACTIVE.label }>
                <CheckIcon color="success"/>;
            </Icon>
        );
    } else {
        return (
            <Icon title={ SupplierStatusEnum.INACTIVE.label }>
                <ClearIcon color="error"/>;
            </Icon>
        );
    }
};

export const getButtonText = (active) => {
    return active ? 'Dezaktywuj' : 'Aktywuj';
};

export const getUpdateSupplierStatus = (active) => {
    return active ? SupplierStatusFormEnum.DEACTIVATE : SupplierStatusFormEnum.ACTIVATE;
};
